import { render } from "./TheSideMenu.vue?vue&type=template&id=36431531&scoped=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=36431531&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36431531"]])

export default __exports__